import { AlertTriangle } from 'lucide-react'
import { estiloDeBoton } from '@/shared/lib/estilosDeBoton'
import { CapaDeModal } from '@/shared/components/CapaDeModal'

interface Props {
  /** Lo que se intentó eliminar, para encabezar el aviso. */
  nombre?: string
  /** El motivo tal como lo devolvió el servidor. */
  motivo: string
  onCerrar: () => void
}

/**
 * El borrado no procedió, y por qué.
 *
 * Va en modal y no en la franja de error de la pantalla porque este caso pide
 * una acción antes de volver a intentar —devolver las herramientas, reasignar
 * las requisiciones— y una franja arriba se pasa por alto: la persona ve que la
 * fila no desapareció y lo vuelve a intentar igual.
 *
 * El texto viene del servidor a propósito. Es quien sabe qué lo detuvo y
 * nombra los registros concretos; repetirlo aquí sería mantener dos versiones
 * de la misma regla, y la de la pantalla quedaría vieja.
 */
export const EliminacionBloqueada = ({ nombre, motivo, onCerrar }: Props) => (
  <CapaDeModal zIndex={60} onClickFondo={onCerrar}>
    <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
      <div className="flex justify-center mb-4">
        <div className="w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center">
          <AlertTriangle className="w-7 h-7 text-amber-500" />
        </div>
      </div>

      <h3 className="text-base font-semibold text-gray-900 text-center mb-2">
        No se puede eliminar todavía
      </h3>

      {nombre && (
        <p className="text-sm text-gray-500 text-center mb-3">{nombre}</p>
      )}

      <div className="text-sm text-gray-700 bg-gray-50 rounded-lg p-3 mb-5">
        {motivo}
      </div>

      <button
        type="button"
        onClick={onCerrar}
        className={estiloDeBoton('primario', 'w-full')}
      >
        Entendido
      </button>
    </div>
  </CapaDeModal>
)
